export default __webpack_public_path__ + "static/media/newLogo.1872510f.png";